
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAPICall } from '../../hooks/useAPICall';
import '../../css/main.css';



export function LoginForm() {

  const navigate = useNavigate();

  const { MakeCall } = useAPICall();

  function handleLoginComplete(data)
  {
    if (data.components['result'].succeeded === true) {
      sessionStorage.setItem('Authed', 'true');
      navigate('/Home');
    }
  }

  function handleLogin() {
    MakeCall('Login/login', "{ \"username\" : \"" + document.getElementById("email").value + "\", \"password\" : \"" + document.getElementById("password").value + "\"}", handleLoginComplete, true);
    console.log("LOGIN");
   
  }


  document.onkeydown = keyPress;

  function keyPress(e){
    var x = e || window.event;
    var key = (x.keyCode || x.which);
    if(key === 13 || key === 3){     
     handleLogin();
    }
  }

  return (
    <>
      <div className='loginwindow'>
        <div className='loginform'>
          <div className='titlediv'>PRC Membership Login</div>
          <div style={{width: "100%"}}>
            <div className='labeldiv'>
              <label>Username</label>
            </div>
            <div>
              <input className='logininput' placeholder='username' id='email' type='email'></input>
            </div>
            <div className='labeldiv'>
              <label>Password</label>
            </div>
            <div>
              <input className='logininput' placeholder='password' id='password' type='password'></input>
            </div>
            <div className='buttondiv' style={{paddingTop : "25px"}}>
              <button className='prcbtn' type='button' onClick={handleLogin}>Login</button>
            </div>
            <div><a href='/ForgotPassword'>Forgotten Password?</a></div>
          </div>
        </div>
        
      </div>

    </>
  );
}


